import React, { FC, useContext } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withSitecoreContext, Text, DateField } from '@sitecore-jss/sitecore-jss-react';
import { CustomText } from '../../../@shared/customText';
import { NewsListingItemModel } from '../../models/newsListing.model';
import { TNewsListingItem } from '../../types/newsListing.types';
import { WithSitecoreContextProps } from '@sitecore-jss/sitecore-jss-react/types/enhancers/withSitecoreContext';
import ctaTypes from '../../../../enums/CTA.enums';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import Media from '../media';
import { NewsListingPlaceholderImgContext } from '../newsListingContext';
import useFormatDate from '../../../../hooks/useFormatDate';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import CTA from '../../../@shared/cta';
import { getDLMFormatDate, googleClickNewsCtaEvent } from '../../../../utils/analytics';
import SocialMediaBar from '../../../@shared/socialMediaBar';
import { TSocialMediaBarProps } from '../../../@shared/socialMediaBar/types/socialMediaBar.types';

const NewsCard: FC<WithTranslation & WithSitecoreContextProps & TNewsListingItem & { index: number; socialMediaBarProps?: TSocialMediaBarProps; }> = (props) => {
  const { t } = props;
  const placeholderImage = useContext(NewsListingPlaceholderImgContext);
  const model = new NewsListingItemModel(props);
  const isEE = props.sitecoreContext?.pageEditing;
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);
  const formattedDate = useFormatDate(model.newsDate);
  const formattedDLMDate = model.newsDate ? getDLMFormatDate(model.newsDate) : '';
  const shareURL = new URL(model.ctaLink || '', props?.sitecoreContext?.currentPageUrl as string || '').href;

  return (
    <div className="news-listing-card">
      {model.tag ? (
        <div className="news-listing-card__badge">
          <Text field={{ value: model.tag }} tag="p" />
        </div>
      ) : null}
      <Media
        desktopImage={model?.desktopImage}
        mobileImage={model?.mobileImage}
        isDesktop={isWide}
        useVideo={model?.useVideo}
        videoUrl={model?.video}
        defaultImage={placeholderImage}
      />
      <div className="news-listing-card__border">
        <div className='news-listing-card__date-share'>
          {model?.newsDate && (
            <DateField
              field={{ value: model.newsDate }}
              tag="div"
              className="news-listing-card__text news-listing-card__date"
              render={() => formattedDate}
            />
          )}
          {props.socialMediaBarProps && (
            <SocialMediaBar
              {...props.socialMediaBarProps}
              listType='dropdown'
              useAnalytics={true}
              shareURL={shareURL}
              showInMobile={true}
            />
          )}
        </div>
        {model.title && (
          <CustomText tag="div" field={{ value: model.title }} className="news-listing-card__text news-listing-card__text--title" />
        )}
        {model.shortDescription && (
          <Text tag="div" field={{ value: model.shortDescription }} className="news-listing-card__text news-listing-card__text--content" />
        )}
        <div className="news-listing-card__button-wrapper">
          {isEE ? (
            <RoutableSitecoreLink
              className="news-listing-card__button"
              field={{
                value: {
                  href: model?.ctaLink,
                },
              }}
              target={model?.ctaLink}
            />
          ) : (
            model?.ctaLink && (
              <CTA
                type={ctaTypes.primaryRed}
                href={model?.ctaLink}
                target={model?.ctaLink}
                extraClassName="news-listing-card__button"
                onClick={() => googleClickNewsCtaEvent(model.title || '', props.index + 1, model.tag, formattedDLMDate)}
              >
                {t('cnhi-readMore')}
              </CTA>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(withTranslation()(NewsCard));
